const style = (theme) => {
  const output = {
    root: {
      minHeight: '100vh',
      // paddingTop: (props) => (props.headerHeight + 80),
    },
    wrap: {
      extend: theme.wrapper,
      position: 'relative',
    },
    heroContainer: {
      height: '60vh',
      position: 'relative',
      '& img': {
        position: 'absolute',
        zIndex: 0,
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        objectFit: 'cover',
      },
      '&:before': {
        content: '""',
        position: 'absolute',
        zIndex: 1,
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        background: theme.getRgba(theme.colors[2], 0.4),
      },
    },
    heroContent: {
      position: 'absolute',
      zIndex: 2,
      left: '7vw',
      bottom: 40,
      color: theme.colors[1],
      '& h1': {
        extend: theme.typography.headings,
        textTransform: 'uppercase',
        fontSize: '7vw',
        lineHeight: 1,
        marginBottom: 10,
        transform: 'translateX(-.1em)',
      },
      '& span + a': {
        marginLeft: 10,
      },
    },
    intro: {
      extend: theme.wrapper,
      '& > *:not(:last-child)': {
        marginBottom: 50,
      },
      '& p': {
        color: theme.colors[0],
        fontSize: 18,
        lineHeight: 1.5,
        '& a': {
          color: theme.colors[0],
          position: 'relative',
          fontFamily: theme.fonts[0],
          '&:before': {
            content: '""',
            position: 'absolute',
            zIndex: -1,
            bottom: 0,
            left: 0,
            width: '100%',
            height: 1,
            background: theme.colors[0],
            transformOrigin: '100% 0',
            transform: 'scaleX(0)',
            transition: `transform .5s ${theme.easings['power4.out']}`,
            willChange: 'transform',
          },
          '&:hover': {
            '&:before': {
              transformOrigin: '0% 0',
              transform: 'scaleX(1)',
            },
          },
        },
      },
    },
    introText: {
      position: 'relative',
      zIndex: 2,
    },
    listIntro: {
      position: 'relative',
      zIndex: 1,
      '& h1': {
        textTransform: 'uppercase',
        margin: 0,
        fontSize: 'calc(52px + 6vw)',
        color: theme.colors[5],
        fontFamily: theme.fonts[1],
        lineHeight: '0.9',
      },
    },
    products: {
      marginTop: 80,
      marginBottom: 80,
      display: 'flex',
    },
    sidebar: {
      flex: '0 0 25%',
      paddingRight: 60,
      '& h3': {
        marginBottom: 20,
      },
    },
    checkbox: {
      margin: [10, 0],
      userSelect: 'none',
      '& label': {
        zIndex: '1',
        overflow: 'hidden',
        position: 'relative',
        cursor: 'pointer',
      },
      '& input': {
        top: '0',
        left: '0',
        opacity: '0.001',
        position: 'absolute',
        '& + span': {
          display: 'inline-block',
          zIndex: '1',
          position: 'relative',
          paddingLeft: '26px',
          '&:before': {
            top: '2px',
            left: '0',
            width: '16px',
            height: '16px',
            border: '1px solid rgba(0, 0, 0, 0.3)',
            cursor: 'pointer',
            content: '""',
            zIndex: '1',
            position: 'absolute',
            background: theme.colors[1],
            transition: 'all .2s ease-in-out',
            borderRadius: '2px',
          },
        },
        '&:checked': {
          '& + span': {
            '&:before': {
              border: '1px solid rgba(0, 0, 0, 0.8)',
            },
            '&:after': {
              content: '""',
              height: '6px',
              width: '10px',
              position: 'absolute',
              zIndex: '1',
              left: '3px',
              top: '6px',
              transform: 'scaleX(.9) rotate(135deg)',
              border: '3px solid black',
              borderLeft: 'none',
              borderBottom: 'none',
              borderRadius: '1px',
            },
          },
        },

      },
    },
    productView: {
      flex: '0 0 75%',
      display: 'flex',
      flexFlow: 'row wrap',
      justifyContent: 'flex-start',
      marginLeft: 'auto',
      marginRight: -30,
      '& .productItem__root': {
        display: 'flex',
        flexDirection: 'column',
        marginBottom: 58,
        width: 'calc(100% / 3)',
        padding: '0 30px',
      },
      '& .productItem__image': {
        paddingBottom: '100%',
      },
      '& .productItem__desc': {
        paddingTop: 20,
      },
    },
    readmore: {
      width: 'calc(75% - 30px)',
      textAlign: 'center',
      marginLeft: 'auto',
    },
    heading: {
      position: 'relative',
      '& .borderedTitle__root': {
        zIndex: 1,
      },
    },
    filtersMobile: {},
    btnOpenFiltersMobile: {},
    filtersMobileOpen: {},
    filtersMobileHeader: {},
    filtersMobileContent: {},
    filtersMobileFooter: {},
    btnResetFilter: {},
    btnApplyFilter: {},
  }

  /*------------------------------
  LG
  ------------------------------*/
  output[theme.mediaInverse.xl] = {
    sidebar: {
      flex: '0 0 300px',
      paddingRight: 30,
    },
    productView: {
      flex: '1 1 100%',
      marginRight: -20,
      marginLeft: -20,
      '& .productItem__root': {
        width: 'calc(100% / 2)',
        padding: '0 20px',
      },
    },
    readmore: {
      width: 'calc(100% - 300px)',
    },
  }

  /*------------------------------
  MD
  ------------------------------*/
  output[theme.mediaInverse.md] = {
    productView: {
      flex: '1 1 100%',
    },
    readmore: {
      width: '100%',
    },
    listIntro: {
      '& h1': {
        fontSize: 'calc(45px + 4vw)',
      },
    },

    btnOpenFiltersMobile: {
      extend: theme.typography.button,
      marginTop: 40,
      display: 'block',
      position: 'relative',
      paddingLeft: '50px',
      '& svg': {
        fill: 'white',
        display: 'inline',
        width: '18px',
        height: '18px',
        position: 'absolute',
        top: '10px',
        left: '23px',
      },
    },
    filtersMobile: {
      display: 'none',
      position: 'fixed',
      top: 0,
      left: 0,
      zIndex: theme.zindex.header,
      height: 'calc(var(--vh) * 100)',
      width: '100vw',
      overflow: 'hidden',
      background: theme.colors[1],
    },
    filtersMobileOpen: {
      display: 'block',
    },
    filtersMobileHeader: {},
    filtersMobileContent: {
      paddingBottom: 80,
      overflowY: 'auto',
      height: 'calc(var(--vh) * 100)',
      '& h3': {
        padding: [15, 0],
      },
    },
    filtersMobileFooter: {
      position: 'absolute',
      bottom: 0,
      left: 0,
      width: '100%',
      zIndex: 2,
      borderTop: '1px solid rgba(0, 0, 0, 0.1)',
      background: theme.colors[1],
      '& $wrap': {
        display: 'flex',
        paddingTop: 10,
        paddingBottom: 10,
        justifyContent: 'flex-end',
      },
      '& button': {
        extend: theme.typography.button,
      },
    },
    btnResetFilter: {
      background: 'rgba(0, 0, 0, .1)!important',
      color: `${theme.colors[0]}!important`,
    },
    btnApplyFilter: {
    },
  }

  /*------------------------------
  SM
  ------------------------------*/
  output[theme.mediaInverse.sm] = {
    heroContent: {
      bottom: 30,
      left: 30,
      '& h1': {
        fontSize: 42,
      },
      '& span + a': {
        margin: [10, 0, 0, 0],
        display: 'block',
      },
    },
    listIntro: {
      '& h1': {
        paddingTop: 20,
        fontSize: 'calc(30px + 4vw)',
      },
    },
    products: {
      marginTop: 50,
    },
    productView: {
      marginRight: -10,
      marginLeft: -10,
      '& .productItem__root': {
        width: 'calc(100% / 2)',
        padding: '0 10px',
        marginBottom: 25,
      },
    },
    '@global': {
      body: {
        overflowY: (props) => (props.isModalCartVisible ? 'hidden !important' : 'visible'),
      },
    },
  }

  /*------------------------------
  XXS
  ------------------------------*/
  output[theme.mediaInverse.xs] = {
    productView: {
      '& .productItem__cta': {
        display: 'none',
      },
      '& .productItem__title': {
        fontSize: 18,
      },
      '& .productItem__designer': {
        fontSize: 13,
      },
    },
  }

  return output
}

export default style
